export const rolesData = [
  {
    label: 'Clients',
    desc: [
      {
        des: 'Add buildings to the system.',
      },
      {
        des: 'Create a job for technicians and escape plan professionals.',
      },
    ],
  },
  {
    label: 'Technicians and Escape Plan Professionals',
    desc: [
      {
        des: 'View job details.',
      },
      {
        des: 'Send a proposal to clients.',
      },
      {
        des: 'If the proposal is accepted by the client, the client sends a contract.',
      },
      {
        des: 'If the proposal is rejected, the process ends.',
      },
    ],
  },

  {
    label: 'Technicians',
    desc: [
      {
        des: 'Start the drawing process upon receiving the contract.',
      },
      {
        des: 'Upon completion, send the PDF of the drawing to the admin for approval.',
      },
    ],
  },
  {
    label: 'Admin',
    desc: [
      {
        des: 'Review the PDF.',
      },
      {
        des: 'Assign the PDF review to either a fireman or a draftsman.',
      },
      {
        des: 'If issues are found, report them to the technician for rework.',
      },
      {
        des: 'After rework, review the PDF again.',
      },
      {
        des: 'Repeat the review process until the PDF is complete and issue-free.',
      },
      {
        des: 'Once approved, the admin sends the PDF to the client.',
      },
    ],
  },
  {
    label: 'Clients',
    desc: [
      {
        des: 'Receive the PDF from the technician.',
      },
      {
        des: 'Send the PDF to the printer for printing or create a job for the printer.',
      },
    ],
  },
];
